import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=da880b1e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da880b1e')) {
      api.createRecord('da880b1e', component.options)
    } else {
      api.reload('da880b1e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=da880b1e&", function () {
      api.rerender('da880b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4Utkz1jytcoXE/JS/imageCarousel.vue"
export default component.exports